import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, inject } from '@angular/core';
import { Grid as InavistaGrid, GridConfig } from '@inavista/components/grid';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import { exportInavistaGrid } from 'projects/service/src/app/shared/utils/inavista-grid-export';
import { LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { statusPillColor } from 'projects/service/src/app/shared/utils/status-pill-colors';
import { BUSINESS_RULES_COLUMNS, buildBusinessRulesGridConfig } from '../isc-claims-rules.grid.config';

// Claim popup → Rules → Business Rules: the claim's business rules (computed by the claim lines tab), read only.
@Component({
    selector: 'app-isc-claims-business-rules',
    templateUrl: './isc-claims-business-rules.component.html',
    styleUrls: ['./isc-claims-business-rules.component.scss'],
    // The grid reads this.businessRules, not an endpoint.
    providers: [...provideLocalGridRows()],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IscClaimsRulesBusinessComponent implements OnInit, OnChanges {
  private readonly commonService = inject(CommonService);
  private readonly gridRows = inject(LocalRowsGridApi);

  @Input() businessRules: any[];
  @ViewChild('businessRulesGrid') grid: InavistaGrid;

  gridConfig: GridConfig;

  ngOnInit(): void {
    this.gridRows.columns.set(LocalRowsGridApi.schema(BUSINESS_RULES_COLUMNS));
    this.gridConfig = buildBusinessRulesGridConfig({
      canExport: !!this.commonService.roleClaims['AllGrid_Toolbar_Excel_Export']?.visible,
      statusColor: statusPillColor(s => this.commonService.getClaimsRuleStatus(s)),
    });
    this.refreshRows();
  }

  // The claim lines tab rebuilds the rules array when a line changes: show the new statuses.
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['businessRules'] && !changes['businessRules'].firstChange) this.refreshRows();
  }

  refreshRows() {
    this.gridRows.rows.set((this.businessRules ?? []).map((rule, i) => ({ ...rule, __rowKey: i })));
    this.grid?.refresh();
  }

  // Same file as before: the rows the grid shows, the visible columns, "Claims Business Rules(<date>).xlsx".
  onExportRequested() {
    exportInavistaGrid(this.grid, 'Claims Business Rules');
  }
}
